import { useSelector } from 'react-redux';

import { Table, TBody, TElement, THead, TRow } from '@adeccoux/tag-ds';
import { Tenant } from '@hooks/useComponentMapping';
import { ServiceBusMessage } from '@models/serviceBusMessage';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { RootState } from '@store/rootReducer';

interface MessagesTableProps {
  userId: string | undefined;
  messages: ServiceBusMessage[];
}

const columns = [
  { field: 'Count', headerName: 'Count' },
  { field: 'id', headerName: 'id' },
  { field: 'serializedMessage', headerName: 'serializedMessage' },
  { field: 'topic', headerName: 'topic' },
  { field: 'subscription', headerName: 'subscription' },
  { field: 'body', headerName: 'body' },
  { field: 'tenantId', headerName: 'tenantId' },
  { field: 'brand', headerName: 'brand' },
  { field: 'country', headerName: 'country' },
  { field: 'commandName', headerName: 'commandName' },
  { field: 'commandId', headerName: 'commandId' },
  { field: 'correlationId', headerName: 'correlationId' },
  { field: 'eventName', headerName: 'eventName' },
  { field: 'eventId', headerName: 'eventId' },
  { field: 'destinationSystem', headerName: 'destinationSystem' },
  { field: 'originSystem', headerName: 'originSystem' },
  { field: 'error', headerName: 'error' },
  { field: 'metaData', headerName: 'metaData' },
  { field: 'createdAt', headerName: 'createdAt' },
];

export const IntegrationMessageHistoryTable: React.FC<MessagesTableProps> = ({ userId, messages }) => {
  const { tenantId } = useSelector((state: RootState) => state.tenant);

  return (
    <div className="feature-integration-messages-history__table-container ">
      <label>
        <p className="tag-ds subtitle">
          {`Messages for candidate with ${
            tenantId && tenantId === Tenant.Australia ? 'applicationId' : 'aamBeCandidateId'
          }: ${userId}`}
        </p>
        <div className="message-limitation">
          <InfoOutlined color="primary" />
          <p>List is limited to 150 records</p>
        </div>
      </label>
      <Table>
        <THead>
          <TRow>
            {columns.map(({ field, headerName }) => (
              <TElement key={field} className="tdElement">
                {headerName}
              </TElement>
            ))}
          </TRow>
        </THead>
        <TBody>
          {messages?.map((item: ServiceBusMessage, i) => (
            <TRow key={item.id + item.createdAt} style={{ position: 'relative' }}>
              <TElement className="tdElement">{i + 1}</TElement>
              <TElement className="tdElement">{item.id}</TElement>
              <TElement className="tdElement">{item.serializedMessage}</TElement>
              <TElement className="tdElement">{item.topic}</TElement>
              <TElement className="tdElement">{item.subscription}</TElement>
              <TElement className="tdElement">{JSON.stringify(item.body)}</TElement>
              <TElement className="tdElement">{item.tenantId}</TElement>
              <TElement className="tdElement">{item.brand}</TElement>
              <TElement className="tdElement">{item.country}</TElement>
              <TElement className="tdElement">{item.commandName}</TElement>
              <TElement className="tdElement">{item.commandId}</TElement>
              <TElement className="tdElement">{item.correlationId}</TElement>
              <TElement className="tdElement">{item.eventName}</TElement>
              <TElement className="tdElement">{item.eventId}</TElement>
              <TElement className="tdElement">{item.destinationSystem}</TElement>
              <TElement className="tdElement">{item.originSystem}</TElement>
              <TElement className="tdElement">{item.error}</TElement>
              <TElement className="tdElement">{JSON.stringify(item.metaData)}</TElement>
              <TElement className="tdElement">{item.createdAt}</TElement>
            </TRow>
          ))}
        </TBody>
      </Table>
    </div>
  );
};
